import request from "./request";

export default {
    getCategory({ commit, state }) {
        return new Promise((resolve, reject) => {
            request
                .getCategories()
                .then((data) => {
                    commit("SET_CATEGORIES", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}